import { IBulkGetInventoryOnLocation } from 'src/app/inventory/interfaces/bulk-get-inventory-on-location.inteface';
import { ILibertyRxLoadedInventory } from '../../interfaces/ILibertyRxLoadedInventory';
import { INDC } from '../../interfaces/INDC.interface';
import { IInventoryLocation } from '../../interfaces/inventory-location.interface';
import { IInventory } from '../../interfaces/inventory.interface';
import { ITransactionModel } from '../../interfaces/ITransactionModel';
import { InventoryInfoRequest } from '../../interfaces/search-criteria';

export class GetInventoryForDrug {
  static readonly type = '[Transactions] get one inventory item by id';

  constructor(public drugID: string, public locationID?: string) {
  }
}

export class GetInventory {
  static readonly type = '[Transactions] get an inventory by current transaction';

  constructor(public transactionId: string) {
  }
}

export class GetInventoryList {
  static readonly type = '[Transactions] get an inventory list by current pharmacy';

  constructor(public filterData: InventoryInfoRequest) {
  }
}

export class SetActiveInventoryList {
  static readonly type = '[Transactions] set current active inventory list for sorting purposes';

  constructor(public list: IInventory[]) {
  }
}

export class SetArchivedInventoryList {
  static readonly type = '[Transactions] set current archived inventory list for sorting purposes';

  constructor(public list: IInventory[]) {
  }
}

export class SetCurrentInventory {
  static readonly type = '[Transactions] save the inventory to the store';

  constructor(public inventory: IInventory) {
  }
}

export class SetCurrentFilteredInventoryTransactions {
  static readonly type = '[Transactions] Set Current Filtered Inventory Transactions';

  constructor(public transactions: ITransactionModel[]) {
  }

}
export class SetCurrentInventoryFromDrugID {
  static readonly type = 'Grab current inventory for a Drug';

  constructor(public drugID: string) {
  }
}

export class ArchiveNDC {
  static readonly type = '[Transactions] archive inventory by NDC';

  constructor(public inventory: IInventory) {
  }
}

export class UnArchiveNDC {
  static readonly type = '[Transactions] un-archive inventory by NDC';

  constructor(public inventory: IInventory) {
  }
}

export class LoadInventoryFromLibertyRx {
  static readonly type = '[Transactions] Load Inventory From Liberty Rx';

  constructor() {
  }
}

export class CancelLoadInventoryFromLibertyRx {
  static readonly type = '[Transactions] Cancel Load Inventory From Liberty Rx';

  constructor() {
  }
}

export class ClearLoadedLibertyRxInventory {
  static readonly type = '[Transactions] clear loaded LibertyRx inventory';

  constructor() {
  }
}

export class UpdateLibertyRxInventoryRow {
  static readonly type = '[Transactions] update loaded LibertyRx inventory row';

  constructor(public ndc: INDC) { }
}

export class RemoveLoadedLibertyRxInventoryRow {
  static readonly type = '[Transactions] remove loaded LibertyRx inventory row';

  constructor(public ndc: INDC) { }
}

export class DisplayNoLibertySettingPopover {
  static readonly type = '[Transactions] hide No Liberty Setting Popover';

  constructor(public value: boolean) {
  }
}
export class SaveLoadedLibertyRxInventory {
  static readonly type = '[Transactions] Save Loaded LibertyRx Inventoryy';

  constructor(public data: ILibertyRxLoadedInventory[]) {
  }
}

export class DisplayLoadingLibertyRxInventory {
  static readonly type = '[Transactions] Set Loading LibertyRx Inventory';

  constructor(public value: boolean) {
  }
}

export class DisplayNoNewNdcPopover {
  static readonly type = '[Transactions] Display No New Ndc Popover';

  constructor(public value: boolean) {
  }
}

export class GetInventoryOnHandForMoment {
  static readonly type = '[Transactions] get inventory on hand for moment';

  constructor(public drugId: string, public locationId, public moment: Date ) {
  }

}

export class GetLibertyRxLoadStatus {
  static readonly type = '[Transactions] get loaded status';

  constructor() { }
}

export class GetLibertyRxPageInventory {
  static readonly type = '[Transactions] get list of LibertyRx inventory'

  constructor() { }
}

export class SetUserAcknowledgedLibertyRxLoadStatus {
  static readonly type = '[Transactions] User has acknowledged load status'

  constructor() {}
}

export class DisplayLoadLibertyRxInventoryErrorModal {
  static readonly type = '[Transactions] Display Load Liberty Rx Inventory Error Modal';

  constructor(public display: boolean) {
  }
}

export class DisplayLoadLibertyRxInventoryCancelModal {
  static readonly type = '[Transactions] Display Load Liberty Rx Inventory Cancel Modal';

  constructor(public display: boolean) {
  }
}

export class ValidateTransactionDateForInventories {
    static readonly type = '[Transactions] Validate Transaction Date For Inventories';
  
    constructor(public payload) {
    }


}
export class ValidateTransactionDateForAmend {
  static readonly type = '[Transactions] Validate Transaction Date For Amend';

  constructor(public payload) {
  }

}

export class ValidateTransactionDateForCompoundAmendIngredients {
  static readonly type = '[Transactions] Validate Transaction Date For Compound Amend Ingredients';

  constructor(public payload) {
  }

}


export class GetCurrentInventoryTransactions {
  static readonly type = '[Transactions] Get Current Inventory Transactions';

  constructor(public drugId: string) {
  }

}

export class IsLibertyRxIntegrationConfigurationOn {
    static readonly type = '[Transactions] IsLibertyRx Integration Configuration On';

    constructor() {
    }

}
export class SetInventoryLocations {
  static readonly type = '[InventoryLocations] Set Inventory Locations';

  constructor(public locations: IInventoryLocation[]) {
  }

}

export class AddOrUpdateLocation {
  static readonly type = '[InventoryLocations] Add Or Update Location';

  constructor(public location: IInventoryLocation) {
  }

}

export class RemoveLocation {
  static readonly type = '[InventoryLocations] Remove Location';

  constructor(public id: string) {
  }
}

export class GetAllLocations {
  static readonly type = '[InventoryLocations] Get All Locations';

  constructor() {
  }

}

export class MarkLocationAsIrremovable {
  static readonly type = '[InventoryLocations] Mark Location As Irremovable';

  constructor(public id) {
  }

}

export class UpdateLocationActivity {
  static readonly type = '[InventoryLocations] Update Location Activity';

  constructor(public id: string, public isActive: boolean) {
  }

}

export class GetInventoryOnLocation {
  static readonly type = '[InventoryLocations] Get Inventory On Location';

  constructor(public id: string, public drugID: string, public gpi?: string) {
  }

}

export class BulkGetInventoryOnLocation {
  static readonly type = '[InventoryLocations] Bulk Get Inventory On Location';

  constructor(public locationDrugList: IBulkGetInventoryOnLocation[]) {
  }

}

export class BulkGetSimilarOnHandInventory {
  static readonly type = '[Inventory] Bulk Get Similar On Hand Inventory';

  constructor(public gpiArray: string[]) {
  }
}

export class MoveInventory {
  static readonly type = '[Transactions] Move Inventory';

  constructor(public payload) {
  }
}

  export class ClearInventoryState {
    static readonly type = '[Transactions] Clear State';
  
    constructor() {
    }

}